import React from "react";
import Select from "react-select";

const SelectBox = ({
  onInputChangeData,
  label,
  placeholder,
  className,
  name,
  options = [],
  value,
  onChange,
  error,
  setFormErrors = false,
  transparentBorder = false,
  searchQuery,
}) => {
  // ✅ keep styles stable (defined outside component render scope)
  const customStyles = React.useMemo(
    () => ({
      control: (provided, state) => ({
        ...provided,
        borderRadius: "10px",
        borderColor: transparentBorder
          ? "transparent"
          : state.isFocused
          ? "#7ea1f2"
          : "#C1CFEF",
        width: "100%",
        boxShadow: "none",
        "&:hover": {
          borderColor: transparentBorder ? "transparent" : "#7ea1f2",
        },
      }),
      option: (provided, state) => ({
        ...provided,
        backgroundColor: state.isSelected
          ? "#C1CFEF"
          : state.isFocused
          ? "#E5ECFF"
          : "white",
        color: "#102048",
        cursor: "pointer",
      }),
      menu: (provided) => ({
        ...provided,
        zIndex: 9999, // prevent being hidden behind modals
      }),
    }),
    [transparentBorder]
  );

  // ✅ Stable options
  const mappedOptions = React.useMemo(() => {
    const optionsList = options.map((option) => {
      const optionValue =
        option.id ||
        option.transaction_status ||
        option.product_id ||
        option.value;

      const optionLabel =
        (searchQuery && option.mobile_number && option.mobile_number.includes(searchQuery)
          ? option.mobile_number
          : option.name ||
            option.head_name ||
            option.expense_name ||
            option.imei ||
            option.exporter_name ||
            option.product_name ||
            option.label) || "";

      return { value: optionValue, label: optionLabel };
    });

    // ✅ Add "Select All" at the top
    return [{ value: "", label: "Select All" }, ...optionsList];
  }, [options, searchQuery]);

  const selectedOption = mappedOptions.find(
    (opt) => String(opt.value) === String(value)
  ) || null;
  console.log("mapped options... ", mappedOptions)
  return (
    <div className={`${className} w-full relative`}>
      {label && (
        <label className="absolute z-10 font-nunito text-xs text-[#102048] -top-[8px] left-[12px] px-1 bg-white font-semibold">
          {label}
        </label>
      )}
      <Select
        name={name}
        value={selectedOption}
        onChange={(option) => {
          onChange(option);           // just pass the selected option to parent
          if (setFormErrors) setFormErrors({ [name]: null });
        }}
        options={mappedOptions}
        styles={customStyles}
        placeholder={placeholder || "Select"}
        isSearchable
        onInputChange={(input) => onInputChangeData?.(input)}
        classNamePrefix="custom-select"
      />
      {error && <div className="text-red-500 text-sm mt-1">{error}</div>}
    </div>
  );
};

export default SelectBox;